<script setup lang="ts">
import IdeoImage from './IdeoImage.vue';

const props = withDefaults(defineProps<{
    blank?: boolean;
    blankColor?: string;
    blankType?: 'color' | 'avatar';
    block?: boolean;
    center?: boolean;
    fluid?: boolean;
    fluidGrow?: boolean;
    height?: number | string;
    left?: boolean;
    right?: boolean;
    rounded?: false | true | 'top' | 'right' | 'bottom' | 'left' | 'circle' | '0';
    src?: string;
    thumbnail?: boolean;
    width?: number | string;
}>(), {
    blankColor: 'transparent',
    blankType: 'color',
    height: undefined,
    width: undefined,
    rounded: false
});
</script>

<template>
    <IdeoImage
        :blank="props.blank"
        :blank-color="props.blankColor"
        :blank-type="props.blankType"
        :block="props.block"
        :center="props.center"
        :fluid="props.fluid"
        :fluid-grow="props.fluidGrow"
        :height="props.height"
        :left="props.left"
        :right="props.right"
        :rounded="props.rounded"
        :src="props.src"
        :thumbnail="props.thumbnail"
        :width="props.width"
    />
</template>
